import axios, { AxiosHeaders } from 'axios'
import { validateTokens } from '../helpers/getTokens.helper'

const TrackProAPI = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
})

TrackProAPI.interceptors.request.use(async (config) => {
    const { accessToken, graphToken } = await validateTokens();
    (config.headers as AxiosHeaders).set("Authorization", `Bearer ${accessToken}`);
    (config.headers as AxiosHeaders).set("refresh_token", graphToken as string);
    return config;
});

export default TrackProAPI;

export const apiMarketPlace = process.env.REACT_APP_API_MARKET_PLACE ?? '';
